import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-pause',
  templateUrl: './icon-pause.component.html',
  styleUrls: ['./icon-pause.component.scss']
})
export class IconPauseComponent implements OnInit {
  @Input() color: string = '#262628';
  @Input() size: number = 18;

  constructor() { }

  ngOnInit() {
  }

}
